/**
 * Aura 프로모 스티커 호버 목표값 (0 | 1).
 * AuraPromoSticker가 갱신하고, ARBackground가 매 프레임 부드럽게 보간합니다.
 */
export const auraStickerHoverRef = { current: 0 };
